import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as SockJS from 'sockjs-client';
import * as Stomp from 'stompjs';
import { environment } from 'src/environments/environment';
import { MeetingService } from './meeting.service';
import { AgoraConfigService } from 'src/AgoraConfigService';

export interface Transcription {
  text: string;
  speaker: string;
  timestamp: Date;
}

@Injectable({
  providedIn: 'root'
})
export class TranscriptionService {

  private stompClient: any;
  private transcriptions = new BehaviorSubject<Transcription[]>([]);
  private meetingId: string | null = null;
  agoraConfigObject: any;

  constructor(private meetingService: MeetingService,private agoraConfig: AgoraConfigService) {
    // this.initializeWebSocketConnection();
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
  }

  initializeWebSocketConnection(meetingId: string): void {
    const socket = new WebSocket(`${this.agoraConfigObject.webSocketEndPoint}`)
    this.stompClient = Stomp.over(socket);
    this.stompClient.connect({}, () => {
      this.startTranscription(meetingId);
    });
  }
  disconnectWebsocket() {
    if (this.stompClient != null && this.stompClient.connected == true) {
      this.stompClient.disconnect();
    }
  }

  public startTranscription(meetingId: string): void {
    // this.transcriptions.next([]);
    this.meetingId = meetingId;
    this.stompClient.subscribe(`/topic/meeting/${meetingId}/transcription`, (message: any) => {    
      const transcription = JSON.parse(message.body); 
      const currentTranscriptions = this.transcriptions.value;
      this.transcriptions.next([...currentTranscriptions, transcription]);
    });
  }

  public stopTranscription(): void {
    if (this.meetingId) {
      this.stompClient.unsubscribe(`/topic/meeting/${this.meetingId}/transcription`);
      this.meetingId = null;
    }
  }

  public getSpeechContent(meetingId: any): void {
    this.meetingService.fetchSpeechContent(meetingId).subscribe((data: any) => {    
      const currentTranscriptions = this.transcriptions.value;
      this.transcriptions.next(data.body.transcriptions);
    })


  }

  public getTranscriptions(): Observable<Transcription[]> {
    return this.transcriptions.asObservable();
  }

  public clearTranscriptions(): void {
    this.transcriptions.next([]);
  }
}
